'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import './util/initializeImmer';
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import { render } from 'react-dom';
import history from './util/History';
import Favicon from './components/Favicon';
import DocumentHead from './components/portals/DocumentHead'; // Configure the router

import { Router } from 'react-router-dom';
import Routes from './lib/routes'; //Redux

import { Provider } from 'react-redux';
import configureStore from './util/configureStore';
import { TreatmentProvider } from './hooks/useTreatments';
import { ThemeProvider } from './theming/ThemeProvider.js';
export default class App {
  // Kicks off the app. This is intentionally not in the constructor.
  start() {
    this.store = configureStore();
    const languageCode = window.I18N_MANUAL_LANG;
    const I18nProvider = createPublicI18nProvider({
      manuallySetLocale: true
    });
    I18nProvider.setLocale({
      locale: languageCode,
      langEnabled: true
    });
    const langAvailable = initAppTranslations([I18nProvider.register(lang)]);
    langAvailable.then(() => {
      this.startRouter();
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return undefined;
  }

  startRouter() {
    render( /*#__PURE__*/_jsx(Provider, {
      store: this.store,
      children: /*#__PURE__*/_jsx(TreatmentProvider, {
        children: /*#__PURE__*/_jsxs(Router, {
          history: history,
          children: [/*#__PURE__*/_jsx(DocumentHead, {
            children: /*#__PURE__*/_jsx(Favicon, {})
          }), /*#__PURE__*/_jsx(ThemeProvider, {
            children: /*#__PURE__*/_jsx(Routes, {})
          })]
        })
      })
    }), document.getElementsByClassName('page')[0]);
  }

}
new App().start();